import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"CampaignOperatorGameConfig Details"}
                            endpoint={"campaign-operator-gameconfig/read"}
                            relations={["operator_game_config", "operator_game_config.game_config", "operator_game_config.operator", "campaign", "campaign.tenant"]} />
}

export default GameSessionDetailsPage;